import { Injectable, signal, inject } from '@angular/core';
import { colorGallery } from './constants';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor(
  
  ) {}
  private _snackBar = inject(MatSnackBar);
  private clipboard = inject(Clipboard);

  public copy(value: string): void {
    const result = this.clipboard.copy(value);
    // if (result) {
    //   this.openSnackBar('Copied to clipboard successfully', 'Dismiss');
    // }
  }

  public extractDomainNumber(input: string): number | undefined {
    const parts = input.split(" ");
    const lastPart = parts[parts.length - 1];
    const num = parseInt(lastPart, 10);
    return isNaN(num) ? undefined : num;
  }
  
  private openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 30000,
    });
  }

  public fetchColorByIndex(index: number): string {
    return colorGallery[index % colorGallery.length];
  }

  public areDatesDifferent(date1: string, date2: string): boolean {
    const d1 = new Date(date1).toISOString().split('T')[0];
    const d2 = new Date(date2).toISOString().split('T')[0];
    return d1 !== d2;
  }

  public hexToRgb(hex): string {
    // Remove the hash symbol if present
    hex = hex.replace(/^#/, '');

    // Parse the hex color based on its length
    let bigint;
    if (hex.length === 3) {
      // Handle shorthand hex color (e.g., #abc)
      bigint = parseInt(
        hex
          .split('')
          .map((c) => c + c)
          .join(''),
        16
      );
    } else if (hex.length === 6) {
      // Handle full hex color (e.g., #aabbcc)
      bigint = parseInt(hex, 16);
    } else {
      throw new Error('Invalid hex color format');
    }

    // Extract the RGB values
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgb(${r}, ${g}, ${b})`;
  }

  private isDomainTrackClicked = new BehaviorSubject<string>(null);
  public domainTrackClicked = this.isDomainTrackClicked.asObservable();

  public clickDomainTrack(state: string): void {
    this.isDomainTrackClicked.next(state);
  }

  public removeVersionFromAccession(param: string): string {
    return param.replace(/-v\d+$/, '');
  }

  public extractUniprotAccession(input: string): string {
    const match = input.match(/^AF-(.+?)-F\d+$/);
    return match ? match[1] : input;
  }

  // public getSelectionData(regions) {
  //   let selection = [];
  //   if (
  //     regions[0].start < regions[1].start &&
  //     regions[0].end > regions[1].end
  //   ) {
  //     selection.push({
  //       start_residue_number: regions[0].start,
  //       end_residue_number: regions[1].end,
  //       color: '#1AFFBB',
  //       focus: true,
  //       class: 'ms-pae-select-green',
  //     });
  //   } else if (
  //     Math.abs(regions[0].start - regions[1].start) <= 5 ||
  //     Math.abs(regions[0].end - regions[1].end) <= 5
  //   ) {
  //     selection.push({
  //       start_residue_number: Math.min(regions[0].start, regions[1].start),
  //       end_residue_number: Math.max(regions[0].end, regions[1].end),
  //       color: '#1AFFBB',
  //       focus: true,
  //       class: 'ms-pae-select-green',
  //     });
  //   } else {
  //     selection.push(
  //       {
  //         start_residue_number: regions[0].start,
  //         end_residue_number: regions[0].end,
  //         color: '#FFA500',
  //         focus: true,
  //         class: 'ms-pae-select-orange',
  //       },
  //       {
  //         start_residue_number: regions[1].start,
  //         end_residue_number: regions[1].end,
  //         color: '#1AFFBB',
  //         focus: true,
  //         class: 'ms-pae-select-green',
  //       }
  //     );
  //   }
  //   return selection;
  // }

  public getSelectionData(regions) {
    const selection = [];
    if (
      Math.abs(regions[0].start - regions[1].start) <= 5 && // using || instead of && here was a bug
      Math.abs(regions[0].end - regions[1].end) <= 5
    ) {
      // Selection is nearly symmetric
      selection.push({
        start_residue_number: Math.min(regions[0].start, regions[1].start),
        end_residue_number: Math.max(regions[0].end, regions[1].end),
        color: '#FFFF00',
        focus: true,
        class: 'ms-pae-select-yellow',
        // TODO update pdbe-molstar to >=3.8.0 and use .visual.sequenceColor(), .visual.clearSequenceColor() instead of hacking Molstar UI via CSS
      });
    } else {
      // Selection is not nearly symmetric
      selection.push(
        {
          start_residue_number: regions[0].start,
          end_residue_number: regions[0].end,
          color: '#FFA500',
          focus: true,
          class: 'ms-pae-select-orange',
        },
        {
          start_residue_number: regions[1].start,
          end_residue_number: regions[1].end,
          color: '#1AFFBB',
          focus: true,
          class: 'ms-pae-select-green',
        }
      );
      const overlapStart = Math.max(regions[0].start, regions[1].start);
      const overlapEnd = Math.min(regions[0].end, regions[1].end);
      if (overlapStart <= overlapEnd) {
        // Add overlap
        selection.push(
          {
            start_residue_number: overlapStart,
            end_residue_number: overlapEnd,
            color: '#FFFF00',
            focus: true,
            class: 'ms-pae-select-yellow',
          }
        );
      }
    }
    return selection;
  }
}
